export const COUNTRIES: Country[] = [
  {
    iso: 'AT',
    name: 'Austria',
    nameDe: 'Österreich',
    iso3: 'AUT',
    numcode: 40,
    phonecode: 43,
    european: true,
  },
  {
    iso: 'BA',
    name: 'Bosnia and Herzegovina',
    nameDe: 'Bosnien und Herzegovina',
    iso3: 'BIH',
    numcode: 70,
    phonecode: 387,
    european: true,
  },
  {
    iso: 'BE',
    name: 'Belgium',
    nameDe: 'Belgien',
    iso3: 'BEL',
    numcode: 56,
    phonecode: 32,
    european: true,
  },
  {
    iso: 'BG',
    name: 'Bulgaria',
    nameDe: 'Bulgarien',
    iso3: 'BGR',
    numcode: 100,
    phonecode: 359,
    european: true,
  },
  {
    iso: 'CA',
    name: 'Canada',
    nameDe: 'Kanada',
    iso3: 'CAN',
    numcode: 124,
    phonecode: 1,
    european: false,
  },
  {
    iso: 'CH',
    name: 'Switzerland',
    nameDe: 'Schweiz',
    iso3: 'CHE',
    numcode: 756,
    phonecode: 41,
    european: true,
  },
  {
    iso: 'CN',
    name: 'China',
    nameDe: 'China',
    iso3: 'CHN',
    numcode: 156,
    phonecode: 86,
    european: false,
  },
  {
    iso: 'CZ',
    name: 'Czech Republic',
    nameDe: 'Tschechien',
    iso3: 'CZE',
    numcode: 203,
    phonecode: 420,
    european: true,
  },
  {
    iso: 'DE',
    name: 'Germany',
    nameDe: 'Deutschland',
    iso3: 'DEU',
    numcode: 276,
    phonecode: 49,
    european: true,
  },
  {
    iso: 'DK',
    name: 'Denmark',
    nameDe: 'Dänemark',
    iso3: 'DNK',
    numcode: 208,
    phonecode: 45,
    european: true,
  },
  {
    iso: 'ES',
    name: 'Spain',
    nameDe: 'Spanien',
    iso3: 'ESP',
    numcode: 724,
    phonecode: 34,
    european: true,
  },
  {
    iso: 'FI',
    name: 'Finland',
    nameDe: 'Finnland',
    iso3: 'FIN',
    numcode: 246,
    phonecode: 358,
    european: true,
  },
  {
    iso: 'FR',
    name: 'France',
    nameDe: 'Frankreich',
    iso3: 'FRA',
    numcode: 250,
    phonecode: 33,
    european: true,
  },
  {
    iso: 'GR',
    name: 'Greece',
    nameDe: 'Griechenland',
    iso3: 'GRC',
    numcode: 300,
    phonecode: 30,
    european: true,
  },
  {
    iso: 'HR',
    name: 'Croatia',
    nameDe: 'Kroatien',
    iso3: 'HRV',
    numcode: 191,
    phonecode: 385,
    european: true,
  },
  {
    iso: 'HU',
    name: 'Hungary',
    nameDe: 'Ungarn',
    iso3: 'HUN',
    numcode: 348,
    phonecode: 36,
    european: true,
  },
  {
    iso: 'IE',
    name: 'Ireland',
    nameDe: 'Irland',
    iso3: 'IRL',
    numcode: 372,
    phonecode: 353,
    european: true,
  },
  {
    iso: 'IT',
    name: 'Italy',
    nameDe: 'Italien',
    iso3: 'ITA',
    numcode: 380,
    phonecode: 39,
    european: true,
  },
  {
    iso: 'LI',
    name: 'Liechtenstein',
    nameDe: 'Liechtenstein',
    iso3: 'LIE',
    numcode: 438,
    phonecode: 423,
    european: true,
  },
  {
    iso: 'LT',
    name: 'Lithuania',
    nameDe: 'Litauen',
    iso3: 'LTU',
    numcode: 440,
    phonecode: 370,
    european: true,
  },
  {
    iso: 'LU',
    name: 'Luxembourg',
    nameDe: 'Luxemburg',
    iso3: 'LUX',
    numcode: 442,
    phonecode: 352,
    european: true,
  },
  {
    iso: 'MT',
    name: 'Malta',
    nameDe: 'Malta',
    iso3: 'MLT',
    numcode: 470,
    phonecode: 356,
    european: true,
  },
  {
    iso: 'NL',
    name: 'Netherlands',
    nameDe: 'Niederlande',
    iso3: 'NLD',
    numcode: 528,
    phonecode: 31,
    european: true,
  },
  {
    iso: 'NO',
    name: 'Norway',
    nameDe: 'Norwegen',
    iso3: 'NOR',
    numcode: 578,
    phonecode: 47,
    european: true,
  },
  {
    iso: 'PL',
    name: 'Poland',
    nameDe: 'Polen',
    iso3: 'POL',
    numcode: 616,
    phonecode: 48,
    european: true,
  },
  {
    iso: 'PT',
    name: 'Portugal',
    nameDe: 'Portugal',
    iso3: 'PRT',
    numcode: 620,
    phonecode: 351,
    european: true,
  },
  {
    iso: 'RO',
    name: 'Romania',
    nameDe: 'Rumänien',
    iso3: 'ROM',
    numcode: 642,
    phonecode: 40,
    european: true,
  },
  {
    iso: 'RS',
    name: 'Serbia',
    nameDe: 'Serbien',
    iso3: 'SRB',
    numcode: 688,
    phonecode: 381,
    european: true,
  },
  {
    iso: 'SE',
    name: 'Sweden',
    nameDe: 'Schweden',
    iso3: 'SWE',
    numcode: 752,
    phonecode: 46,
    european: true,
  },
  {
    iso: 'SI',
    name: 'Slovenia',
    nameDe: 'Slovenien',
    iso3: 'SVN',
    numcode: 705,
    phonecode: 386,
    european: true,
  },
  {
    iso: 'SK',
    name: 'Slovakia',
    nameDe: 'Slowakei',
    iso3: 'SVK',
    numcode: 703,
    phonecode: 421,
    european: true,
  },
  {
    iso: 'UK',
    name: 'United Kingdom',
    nameDe: 'Grossbritannien',
    iso3: 'GBR',
    numcode: 826,
    phonecode: 44,
    european: true,
  },
  {
    iso: 'US',
    name: 'United States',
    nameDe: 'Vereinigte Staaten',
    iso3: 'USA',
    numcode: 840,
    phonecode: 1,
    european: false,
  },
  {
    iso: 'LV',
    name: 'Latvia',
    nameDe: 'Lettland',
    iso3: 'LVA',
    numcode: 428,
    phonecode: 371,
    european: true,
  },
];

export interface Country {
  iso: string;
  name: string;
  nameDe: string;
  iso3: string;
  numcode: number;
  phonecode: number;
  european: boolean;
}
